import * as React from 'react';

import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  TextField,
  DateField,
  required,
} from 'react-admin';

export const GMDNTermList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="gmdnPTName" />
      <TextField source="gmdnPTDefinition" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);

export const GMDNTermCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="gmdnPTName" validate={required()} />
      <TextInput source="gmdnPTDefinition" validate={required()} />
    </SimpleForm>
  </Create>
);

export const GMDNTermEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="gmdnPTName" validate={required()} />
      <TextInput source="gmdnPTDefinition" validate={required()} />
    </SimpleForm>
  </Edit>
);
